import _ from "lodash";
import "./Prices.scss";
import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  name: "Prices",
  components: { POIStep },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    priceTab: 0,
    seasons: [
      { value: "always", title: "Ganzjährig" },
      { value: "summer", title: "Sommer" },
      { value: "winter", title: "Winter" }
    ],
    costs: [
      { value: "free", title: "kostenlos" },
      { value: "chargeable", title: "kostenpflichtig" }
    ],
    dragging: false,
    fileUrls: []
  }),
  methods: {
    addPricePackage() {
      const id =
        (this.pricePackages?.[this.pricePackages.length - 1]?.id ?? 1) + 1;
      this.pricePackages.push({
        id,
        tabTitle: "Preise",
        services: [{ id: 0, prices: [{}] }]
      });

      this.priceTab = id;
    },
    addPrice(service, priceIndex) {
      service?.prices?.splice(priceIndex + 1, 0, {});
    },
    removePricePackage() {
      if (this.priceTab !== 0) this.pricePackages.splice(this.priceTab, 1);
    },
    removePrice(service, price) {
      service?.prices?.remove(price);
    },
    addService(price) {
      const id = (price?.services?.[price?.services?.length - 1]?.id ?? 0) + 1;
      price?.services?.push({ id, prices: [{}] });
    },
    removeService(pricePackage, index) {
      pricePackage.services.splice(index, 1);
    },
    copyService(pricePackage, service, index) {
      pricePackage.services.splice(index, 0, { ..._.cloneDeep(service) });
    },
    move(service, index, direction) {
      // Direction: true = down, false = up
      const itemToMove = service?.prices?.[index],
        newIndex = direction ? index + 1 : index - 1;
      service?.prices?.splice(index, 1);
      service?.prices?.splice(newIndex, 0, itemToMove);
    },
    addDropFile(e, price) {
      price.serviceUpload = this.fileUrls = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      this.dragging = false;
      price.serviceUpload = Array.from(files);
      price.serviceUpload.forEach(file => {
        const reader = new FileReader();
        reader.onload = ({ target }) => {
          if (target?.result) this.fileUrls.push(target.result);
        };
        reader.readAsDataURL(file);
      });
    },

    changeStep(position) {
      this.$emit("changeStep", position);
    },
    movePricePackage(index, direction) {
      const itemToMove = this.pricePackages?.[index],
        newIndex = direction ? index + 1 : index - 1;
      this.pricePackages?.splice(index, 1);
      this.pricePackages?.splice(newIndex, 0, itemToMove);
      this.priceTab = newIndex;
    },
    onTabChange(clickedTab) {
      this.priceTab = clickedTab;
    }
  },
  created() {
    this.$store.dispatch("getFeatureGroupsForPois");
  },
  computed: {
    pricePackages: {
      get() {
        return (
          this.editedItem?.pricePackages ?? [
            { id: 0, tabTitle: "Preise", services: [{ id: 0 }] }
          ]
        );
      },
      set(value) {
        this.editedItem.pricePackages = value;
      }
    },
    featureGroups() {
      return this.$store.state.featureGroups;
    },
    features() {
      return _.flatten(this.featureGroups.map(fg => fg.features));
    }
  }
};
